import React from 'react';
interface LeafAccentProps {
  className?: string;
}
export function LeafAccent({
  className = ''
}: LeafAccentProps) {
  return <div className={`flex justify-center opacity-20 ${className}`} data-id="element-202">
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-203">
        <path d="M12 22C12 22 20 18 20 12C20 6 12 2 12 2C12 2 4 6 4 12C4 18 12 22 12 22Z" stroke="#2D6A4F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-204" />
        <path d="M12 22V12" stroke="#2D6A4F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-205" />
        <path d="M12 16L16 12" stroke="#2D6A4F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-206" />
        <path d="M12 12L8 8" stroke="#2D6A4F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-207" />
      </svg>
    </div>;
}